import { db } from "../../server";
import { interpolate } from "../helpers/stringHelper";
import { paths } from "../constants/dbPaths";
import { instance } from "../apiclient";
import { DetectBrand } from "../../mixins/brandDetector";
import { logger } from "../Logger";

export function getStore(id) {
  return db.collection(paths.StoreCollection).doc(id);
}
export function getStoreBySlug(slug) {
  return db.collection(paths.StoreCollection).where("Slug", "==", slug);
}
export function getBlackoutDates(storeId) {
  return db.doc(interpolate(paths.BlackoutDatesCollection, storeId));
}
export function getStoreByHqID(HqID) {
  return db.collection(paths.StoreCollection).where("HQCompanyID", "==", HqID);
}
export function getStoreWithName(name) {
  return db.collection(paths.StoreCollection).where("Name", "==", name);
}
export function getStores() {
  return db.collection(paths.StoreCollection).where("IsTest", "==", false);
}
export async function getHQStore(hqId) {
  let query = null;
  if (hqId) {
    query = await db.collection(paths.StoreCollection).doc(hqId).get();
    if (query.exists) {
      return query.data();
    }
  } else {
    query = await db
      .collection(paths.StoreCollection)
      .where("IsHQ", "==", true)
      .get();
    if (!query.empty) {
      return query.docs[0].data();
    }
  }
  return null;
}
export function getStoreMenus(storeId) {
  return db.collection(interpolate(paths.StoreMenus, storeId));
}
export async function getUpsellMenus(storeId) {
  let menus = {};
  const query = await db
    .collection(interpolate(paths.UpsellMenus, storeId))
    .get();
  query.docs.forEach((doc) => {
    menus[doc.id] = doc.data();
  });
  return menus;
}
export function getCategoryTimeSettings(storeId, callback) {
  db.collection(interpolate(paths.CategoryTimeSettings, storeId)).onSnapshot(
    (snapshot) => {
      const ts = {};
      snapshot.docs.forEach((doc) => {
        ts[doc.id] = doc.data();
      });
      callback(ts);
    }
  );
}
export function getMenuDoc(storeId) {
  return db.doc(interpolate(paths.MenuDoc, storeId));
}
export function getPayTableConfig(storeId) {
  return db.doc(interpolate(paths.PayTableDoc, storeId));
}
export function getStoreMenuDoc(storeId, menuName) {
  return db.doc(interpolate(paths.StoreMenuDoc, storeId, menuName));
}
export function getStoresSortByDisplayOrder() {
  return db.collection(paths.StoreCollection).orderBy("DisplayOrder");
}
export function getPriceTriggers(storeId) {
  return db.doc(interpolate(paths.PriceTriggersDoc, storeId));
}

export function getProductStatus(storeId) {
  return db.collection(interpolate(paths.ProductStatus, storeId));
}

export async function createTempOrder(storeId, orderId, payload) {
  try {
    await db
      .collection(paths.StoreCollection)
      .doc(storeId)
      .collection("TempOrders")
      .doc(orderId)
      .set(payload);
    return true;
  } catch (error) {
    logger.logObject(error);
    return false;
  }
}

export async function getTempOrder(storeId, orderId) {
  try {
    return db
      .collection(paths.StoreCollection)
      .doc(storeId)
      .collection("TempOrders")
      .doc(orderId)
      .get();
  } catch (error) {
    return null;
  }
}

export function getStoreWallet(id) {
  return db.doc(interpolate(paths.WalletDoc, id));
}

export function getNewUIStores() {
  return db.collection(paths.NewUI).doc("stores").get();
}
export async function handleIsValidInstance(storeId) {
  const res = await instance.post("stores/valid-instance", {
    storeId: storeId,
    isBranded: DetectBrand.methods.isBranded(),
  });
  return res.data;
}

export function getStoreDefaultMenu(storeId) {
  return db.collection(interpolate(paths.StoreMenus, storeId)).doc("DefaultMenu");
}
